import { Table } from "@/components/elements/Table";
import { useTable } from "@/hooks/useTable";
import { background, divider } from "@/theme/colors";
import { Box, styled } from "@mui/material";
import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
type TLedgerTableProps<T extends MRT_RowData> = {
    columns: MRT_ColumnDef<T>[];
    rows: T[];
    headRowHeight?: number | string;
    bodyRowHeight?: number | string;
    isLoading?: boolean;
    onClickRow?: (row: T) => void;
};
export const LedgerTable = <T extends MRT_RowData>({ columns, rows, headRowHeight = 40, bodyRowHeight = "auto", isLoading, onClickRow, }: TLedgerTableProps<T>) => {
    const { table } = useTable({
        rows,
        columns,
        onClickRow,
        renderEmptyRowsFallback: () => <Box />,
    });
    return (<Wrapper>
      
      
      <Table table={table} headRowHeight={headRowHeight} bodyRowHeight={bodyRowHeight} borderColor={divider.middle} height="100%" minHeight={150} isLoading={isLoading}/>
    </Wrapper>);
};
const Wrapper = styled(Box) `
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  & > * {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
  & .MuiPaper-root {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  & .MuiTableContainer-root {
    flex: 1;
    min-height: 0;
  }

  .MuiTableHead-root .MuiTableCell-head {
    border-right: none;
  }

  .MuiTableHead-root {
    z-index: 5;
  }
  .MuiTableHead-root tr {
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: ${background.primary};
  }
  .MuiTableHead-root:has(.ledger-sub-col) tr:nth-of-type(2) {
    top: 40px;
    z-index: 6;
  }
  .MuiTableHead-root:has(.ledger-leaf-col) tr:nth-of-type(3) {
    top: 80px;
    z-index: 7;
  }
  .MuiTableBody-root .MuiTableRow-root,
  .MuiTableBody-root .MuiTableCell-body:not([data-pinned="true"]) {
    z-index: auto;
  }

  .MuiTableHead-root:has(.ledger-sub-col) tr:first-of-type .MuiTableCell-head[colspan="1"] {
    border-bottom: none !important;
  }

  .MuiTableHead-root:has(.ledger-sub-col):not(:has(.ledger-leaf-col)) tr:last-of-type .MuiTableCell-head[colspan="1"]:not(.ledger-sub-col) {
    border-top: none;
  }
  .MuiTableHead-root:has(.ledger-sub-col):not(:has(.ledger-leaf-col)) tr:last-of-type .MuiTableCell-head[colspan="1"]:not(.ledger-sub-col) .Mui-TableHeadCell-Content {
    justify-content: flex-start;
    transform: translateY(-20px);
  }
  .MuiTableHead-root:has(.ledger-sub-col):not(:has(.ledger-leaf-col)) tr:last-of-type .MuiTableCell-head[colspan="1"]:not(.ledger-sub-col)::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    height: 40px;
    background-color: ${background.primary};
  }

  .MuiTableHead-root:has(.ledger-leaf-col) tr:last-of-type .MuiTableCell-head[colspan="1"]:not(.ledger-sub-col):not(.ledger-leaf-col) {
    border-top: none;
  }
  .MuiTableHead-root:has(.ledger-leaf-col) tr:last-of-type .MuiTableCell-head[colspan="1"]:not(.ledger-sub-col):not(.ledger-leaf-col) .Mui-TableHeadCell-Content {
    justify-content: flex-start;
    transform: translateY(-40px);
  }
  .MuiTableHead-root:has(.ledger-leaf-col) tr:last-of-type .MuiTableCell-head[colspan="1"]:not(.ledger-sub-col):not(.ledger-leaf-col)::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    height: 80px;
    background-color: ${background.primary};
  }
  .MuiTableHead-root:has(.ledger-leaf-col) tr:last-of-type .ledger-sub-col {
    border-top: none;
  }
  .MuiTableHead-root:has(.ledger-leaf-col) tr:last-of-type .ledger-sub-col .Mui-TableHeadCell-Content {
    justify-content: flex-start;
    transform: translateY(-20px);
  }
  .MuiTableHead-root:has(.ledger-leaf-col) tr:last-of-type .ledger-sub-col::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    height: 40px;
    background-color: ${background.primary};
  }

  .MuiTableHead-root .MuiTableCell-head[colspan]:not([colspan="1"]) {
    border-bottom: none;
  }
  .MuiTableHead-root .MuiTableCell-head[colspan]:not([colspan="1"]) .Mui-TableHeadCell-Content {
    justify-content: flex-start;
    text-align: left;
    padding-top: 10px;
  }
  .MuiTableHead-root .MuiTableCell-head {
    vertical-align: middle;
  }
  .MuiTableCell-head .Mui-TableHeadCell-Content {
    align-items: center;
    height: 100%;
    justify-content: flex-start;
  }
  .MuiTableCell-head .Mui-TableHeadCell-Content-Wrapper {
    white-space: pre-line;
    line-height: 1.5;
    overflow: visible;
    text-overflow: clip;
  }
  .MuiTableHead-root .MuiTableCell-head {
    letter-spacing: 0;
  }
  .MuiTableBody-root .MuiTableCell-body {
    line-height: 1.5;
    letter-spacing: 0;
    vertical-align: top;
    padding-top: 12px !important;
    overflow: visible;
  }
`;
